import { DisqualificationReasonSelection } from '@/models/disqualification-reason-selection';
import { EnrichmentSpecification } from '@/models/enrichment-specification';
import { EnrolmentNoCommissionReason, EnrolmentNotEnrolledReason } from '@studyportals/sp-lord-business-interface';
import { SuccessFeeInformation } from './success-fee-information';

export class TriggerPayload {
	public disqualificationReasonSelection: DisqualificationReasonSelection;
	public note?: string;
	public successFeeInformation: SuccessFeeInformation;
	public enrichmentSpecification: EnrichmentSpecification;
	public organisationIdentity: string;
	public reviewReason?: EnrolmentNoCommissionReason | EnrolmentNotEnrolledReason;

	public constructor(
		disqualificationReasonSelection = new DisqualificationReasonSelection(),
		note?: string,
		successFeeInformation = new SuccessFeeInformation(),
		enrichmentSpecification = new EnrichmentSpecification(),
		organisationIdentity = '',
		reviewReason?: EnrolmentNoCommissionReason | EnrolmentNotEnrolledReason
	) {
		this.disqualificationReasonSelection = disqualificationReasonSelection;
		this.note = note;
		this.successFeeInformation = successFeeInformation;
		this.enrichmentSpecification = enrichmentSpecification;
		this.organisationIdentity = organisationIdentity;
		this.reviewReason = reviewReason;
	}

	public hasNote(): boolean {
		return this.note ? this.note.length > 0 : false;
	}
}
